<ng-template #transactionModal let-modal>
    <div class="modal-content" [class.bright]="isBright">
        <div>
            <div class="urn_details_sec">
                <div class="urn_details">
                    <span class="urndetail_li urn_nav_action_back" (click)="scrollLeft($event)">
                        <div class="nav_next_btn">
                            <img src="../../../assets/img/nxt.png" title="Previous" alt="Next">
                        </div>
                    </span>
                    <div class="urn-details-ul-wrp" #widgetsContent>
                        <ul class="urn_details_ul">
                            <li class="urndetail_li">
                                <p class="urn_title">URN</p>
                                <p class="urn_content">{{invoicePrimaryDetails.urn}}</p>
                            </li>
                            <li class="urndetail_li">
                                <p class="urn_title">Type</p>
                                <p class="urn_content">{{invoicePrimaryDetails.docType}}</p>
                            </li>
                            <li class="urndetail_li">
                                <p class="urn_title">Current Status</p>
                                <p class="urn_content">
                                    {{invoicePrimaryDetails.currentStatus}}
                                </p>
                            </li>
                            <li *ngIf="invoicePrimaryDetails.country!=''" class="urndetail_li">
                                <p class="urn_title">Country</p>
                                <p class="urn_content">{{invoicePrimaryDetails.country}}</p>
                            </li>
                            <li class="urndetail_li">
                                <p class="urn_title">URN Created Date</p>
                                <p class="urn_content">{{invoicePrimaryDetails.urnCreatedDate}}</p>
                            </li>
                            <li class="urndetail_li">
                                <p class="urn_title">Source</p>
                                <p class="urn_content">{{invoicePrimaryDetails.source}}</p>
                            </li>
                            <li *ngIf="isShowPriorityButton" class="urndetail_li">
                                <p class="urn_title">Priority</p>
                                <p class="urn_content">
                                    <!-- <i class="material-icons" style="color:gray" title="Priority">priority_high</i> -->
                                    {{invoicePrimaryDetails.priority}}
                                </p>
                            </li>
                            <li class="urndetail_li">
                                <p class="urn_title">Assigned To</p>
                                <p class="urn_content">{{invoicePrimaryDetails.assigned_to_user}}</p>
                            </li>
                        </ul>
                    </div>
                    <span class="urndetail_li urn_nav_action_next" (click)="scrollRight($event)">
                        <div class="nav_prev_btn">
                            <img src="../../../assets/img/nxt.png" title="Next" alt="Next">
                        </div>
                    </span>
                </div>
                <div class="urn_history_sec">
                    <span class="icons_main_box history_icon history_btn_icon waves-effect waves-light"
                        *ngIf="isShowHistoryButton" (click)="getHistory()" title="History">
                        <img src="../../../assets/img/transaction/history.png" alt="History">
                    </span>
                    <span class="icons_main_box view_icon waves-effect waves-light progress_btn"
                        (click)="showHideInvoice()" title="{{isDisplayPDFViewer?'Hide':'Show'}} Invoice">
                        <img src="../../../assets/img/transaction/{{isDisplayPDFViewer?'hide':'view'}}.png" alt="Transaction">
                    </span>
                    <span class="icons_main_box view_icon waves-effect waves-light progress_btn"
                        (click)="openInvoiceFile()" title="Open Invoice">
                        <img src="../../../assets/img/transaction/open.png" alt="Open">
                    </span>
                </div>
                <div class="modal_close_sec">
                    <img src="../../../assets/img/cancel-icon.png" class="modal_close_btn modal-close" alt="Close"
                        (click)="modal.dismiss('Cross click')" >
                </div>
            </div>
        </div>
        <div class="modal-body main-modal custom_modal_body">
            <div class="model_content">
                <div class="modelContent">
                    <div>
                        <div class="general_form_sec history_main_sec p_25" [hidden]="!showHistory">
                            <div class="table_main_sec">
                                <div class="table_heading">History
                                    <img src="../../../assets/img/cancel-icon.png" (click)="showHistory=false"
                                        class="close_table_icon" alt="Cancel">
                                </div>
                                <div class="table_section">
                                    <div class="table-responsive tablecss mt10">
                                        <table class="table custom_table history_table">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Sr No</th>
                                                    <th>From Step</th>
                                                    <th>To Step</th>
                                                    <th>Changed On</th>
                                                    <th>Changed By</th>
                                                    <th>Comment</th>
                                                    <th *ngIf="hasRejectReasonInHistory">Reason</th>
                                                    <th *ngIf="hasChecklistInHistory">Check List</th>
                                                    <th>Duration<small>(d h:m:s)</small></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngFor="let item of transactionHistoryList;let i=index">
                                                    <tr [class.active]="activeHistoryId==item.refId"
                                                        [ngClass]="i==0?'clr-blue':'clr-purple'">
                                                        <td>
                                                            <div *ngIf="attachmentCount(item.refId)>0"
                                                                class="attach_icon_td">
                                                                <img (click)="activeHistoryId=(activeHistoryId==item.refId?0:item.refId)"
                                                                    src="../../../assets/img/transaction/attach-icon.png"
                                                                    alt="Attach">
                                                                <span
                                                                    class="icon_badge">{{attachmentCount(item.refId)}}</span>
                                                            </div>
                                                        </td>
                                                        <td class="font-bold">{{i+1}}</td>
                                                        <td>{{item.fromProcess}}</td>
                                                        <td>{{item.toProcess}}</td>
                                                        <td>{{item.changedDate|date:'dd-MMM-yyyy hh:mm a'}}</td>
                                                        <td>{{item.changedBy}}</td>
                                                        <td>
                                                            <div *ngIf="item.comment.length>0 && item.comment!=''">
                                                                <div *ngIf="item.comment.length>25" class="row">
                                                                    <div class="col-md-9 div_history-comments">
                                                                        {{item.comment}}
                                                                    </div>
                                                                    <div class="col-md-3">
                                                                        <mat-icon mat-raised-button
                                                                            matTooltip="{{item.comment}}"
                                                                            matTooltipClass="history-comments-tooltip">comment</mat-icon>
                                                                    </div>

                                                                </div>
                                                                <div *ngIf="item.comment.length<25"
                                                                    class="row div_history-comments">
                                                                    {{item.comment}}
                                                                </div>

                                                            </div>
                                                        </td>
                                                        <td *ngIf="hasRejectReasonInHistory">
                                                            <div *ngIf="item.reason.length>0 && item.reason!=''">
                                                                <mat-icon title="Reason"
                                                                    [matMenuTriggerFor]="historyReasonMenu">view_list</mat-icon>
                                                                <mat-menu #historyReasonMenu="matMenu">
                                                                    <div class="history_checklist-container">
                                                                        <ul>
                                                                            <div
                                                                                *ngFor="let item of item.reason.split(',')">
                                                                                <li> {{ item }}</li>
                                                                            </div>
                                                                        </ul>
                                                                    </div>
                                                                </mat-menu>
                                                            </div>
                                                        </td>
                                                        <td *ngIf="hasChecklistInHistory">
                                                            <div *ngIf="item.checklist.length>0 && item.checklist!=''">
                                                                <mat-icon title="Check List"
                                                                    [matMenuTriggerFor]="checkListMenu">view_list</mat-icon>
                                                                <mat-menu #checkListMenu="matMenu">
                                                                    <div class="history_checklist-container">
                                                                        <ul>
                                                                            <div
                                                                                *ngFor="let item of item.checklist.split(',')">
                                                                                <li> {{ item }}</li>
                                                                            </div>
                                                                        </ul>

                                                                    </div>
                                                                </mat-menu>
                                                            </div>
                                                        </td>
                                                        <td>{{item.duration}}</td>

                                                    </tr>
                                                    <ng-container
                                                        *ngFor="let file of fileAttachmentHistoryList;let fIndex=index">
                                                        <tr *ngIf="activeHistoryId==item.refId && file.ref_history_id==item.refId"
                                                            class="child" [ngClass]="i==0?'clr-blue':'clr-purple'">
                                                            <td colspan="10">
                                                                <div class="td_content_sec">
                                                                    <div *ngIf="file.isFinalMail==1"
                                                                        class="attach_action mr-2">
                                                                        <img (click)="showModalBody(attachmentMail,file.bodyContent,'lg',file.attachmentMode)"
                                                                            src="../../../assets/img/transaction/view.png"
                                                                            class="view_td_content" alt="View">
                                                                    </div>
                                                                    <div class="attach_content">
                                                                        <p class="title">File Type</p>
                                                                        <p class="content">
                                                                            {{file.isSupportingFile==1?'Supporting
                                                                            File':'Primary Invoice'}}</p>
                                                                    </div>
                                                                    <div class="attach_content">
                                                                        <p class="title">Mode of Attachment</p>
                                                                        <p class="content">{{file.attachmentMode}}</p>
                                                                    </div>
                                                                    <div class="attach_content attach_file_name_sec">
                                                                        <p class="title">File Name</p>
                                                                        <p class="content"
                                                                            title="Click to download attachment"
                                                                            (click)="downloadAttachment(file.actialFileName)">
                                                                            {{file.fileName}}</p>
                                                                    </div>
                                                                    <div class="attach_content">
                                                                        <p class="title">Uploaded By</p>
                                                                        <p class="content">{{file.uploadedBy}}</p>
                                                                    </div>
                                                                    <div class="attach_content">
                                                                        <p class="title">Uploaded Date</p>
                                                                        <p class="content">
                                                                            {{file.uploadedDate|date:'dd-MMM-yyyy hh:mm
                                                                            a'}}</p>
                                                                    </div>
                                                                    <!-- <div class="attach_action">
                                                                        <img (click)="activeHistoryId=0"
                                                                            src="../../../assets/img/cancel-icon.png"
                                                                            class="close_td_content" alt="">
                                                                        <img *ngIf="file.isSupportingFile==1 && file.uploadedById==commonService.getUserInfoFromLocalStorage('userId')"
                                                                            (click)="deleteAttachment(file.id)"
                                                                            src="../../../assets/img/transaction/delete.png"
                                                                            class="close_td_content" alt="">
                                                                    </div> -->
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </ng-container>

                                                </ng-container>

                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>

                            <div *ngIf="doaHistory.length>0" class="table_main_sec">
                                <div class="table_heading mt-3">DOA HISTORY</div>
                                <div class="table_section">
                                    <div class="table-responsive tablecss mt10">
                                        <table class="table custom_table history_table">
                                            <thead>
                                                <tr>
                                                    <th>Approver</th>
                                                    <th>Assigned By</th>
                                                    <th>Assigned Date</th>
                                                    <th>Approved By</th>
                                                    <th>Approved Date</th>
                                                    <th>Current Status</th>
                                                    <th>Level</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of doaHistory;let i=index"
                                                    [ngClass]="i==0?'clr-blue':'clr-purple'">
                                                    <td>{{item.approver}}</td>
                                                    <td>{{item.assignedBy}}</td>
                                                    <td>{{item.assignedDate|date:'dd-MMM-yyyy'}}</td>
                                                    <td>{{item.approvedBy}}</td>
                                                    <td>{{item.approvedDate|date:'dd-MMM-yyyy'}}</td>
                                                    <td>{{item.currentStatus|titlecase}}</td>
                                                    <td>{{item.level}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="processQueue.length>0 && isReadonlyMode==false">
                        <div class="comment-box-main">
                            <div class="row cmnt_sec_h_100">
                                <div class="col-lg-4 cmnt_sec_h_100">
                                    <label>Comments</label>
                                    <div class="cmnt_textarea_sec" [ngClass]="isCommentExpand?'expanded_textarea':''">
                                        <span class="textarea_font_sec" title="Show list of restricted keywords"
                                            (click)="showModal(restrictedKeywordModal,'sm')">
                                            <img src="../../../assets/img/transaction/info.png" alt="Info">
                                        </span>
                                        <span class="expand_textarea_sec" title="Max/Min"
                                            (click)="isCommentExpand = !isCommentExpand">
                                            <img src="../../../assets/img/transaction/expand.png" alt="Expand">
                                        </span>
                                        <span class="textarea_editor_main_sec">
                                            <span class="words_count_limit">
                                                {{wordsTotal}}
                                            </span>
                                        </span>
                                        <span class="comment_mandatory">*</span>
                                        <textarea class="cmnt_textarea" maxlength="1000" required
                                            (blur)="checkRestrictedKeywords()" [(ngModel)]="transactionComment"
                                            (keyup)="function(transactionComment)">{{transactionComment}}</textarea>
                                    </div>
                                </div>
                                <div class="col-lg-8">
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <div class="browsefile_main_section">

                                                <input [attr.type]="fileControlType" #fileUpload id="uploadFileName"
                                                    (change)="onSelectFile($event)" />

                                                <div class="browse_file_sec">
                                                    <img src="../../../assets/img/transaction/cloud-upload-alt.png"
                                                        alt="" title="Browse File">
                                                    <span>Drag & Drop Files</span>
                                                </div>
                                                <div class="browser_or_sec">
                                                    <span>Or</span>
                                                </div>
                                                <div class="browse_file_sec">
                                                    <img src="../../../assets/img/transaction/folder-open-solid.png"
                                                        alt="" title="Browse File">
                                                    <span>Browse File</span>
                                                </div>
                                            </div>
                                            <div class="files_note_sec">
                                                <div class="note">Only {{supportDocValidFileExtensions.join('/ ')}} <br>
                                                    Max {{supportDocFileSize}}MB</div>
                                                <div class="files_uploaded_count">
                                                    {{attachmentList.length}} File is Uploaded. <span
                                                        class="view_uploaded_doc"
                                                        (click)="isShowUploadedDocs = true">View Files</span>
                                                </div>
                                            </div>
                                            <div class="uploaded_files_view_sec" *ngIf="isShowUploadedDocs">
                                                <div class="uploaded_files_header">
                                                    <span>{{attachmentList.length}} files uploaded
                                                        successfully.</span>
                                                    <span (click)="isShowUploadedDocs = false" title="Close"><i
                                                            class="material-icons" title="close">close</i></span>
                                                </div>
                                                <div class="files_list_sec">
                                                    <div class="file_status_sec"
                                                        *ngFor="let file of attachmentList;let i=index">
                                                        <img src="../../../assets/img/transaction/file_uploaded.png"
                                                            class="file_uploaded_icon" alt="" title="Upload File">
                                                        <div class="file_name_sec">
                                                            <div class="file_name_detail">
                                                                <span class="status_file_name">{{file.name}}</span>
                                                                <!-- <img src="../../../assets/img/transaction/view.png"
                                                                    class="files_action_icon" alt=""> -->
                                                                <img (click)="deleteAttachment(i)"
                                                                    src="../../../assets/img/transaction/delete.png"
                                                                    title="Delete"
                                                                    class="files_action_icon file_status_delete" alt="Delete">
                                                            </div>
                                                            <div class="file_status_bar"></div>
                                                        </div>
                                                        <span class="file_checked_icon">
                                                            <img src="../../../assets/img/transaction/checked.png"
                                                                alt="" title="File Check">
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-8 text-end">
                                            <div *ngIf="isPageFullyLoaded">
                                                <ng-container *ngFor="let queue of processQueue">
                                                    <button (click)="validateTransactionAndSubmit(queue.process_id)"
                                                        class="btncss mr-2 mb-2 btn_primary btn_thin">
                                                        {{selectedDOAApprover!=0 &&
                                                        doaMatrix.approved_process_id==queue.process_id?'Send To Next
                                                        Approver': queue.process_name}}
                                                    </button>
                                                </ng-container>
                                            </div>
                                            <input
                                                *ngIf="commonService.sesLineitemFetchRequired && fetchSesLineitemAPI!=''"
                                                type="button" class="btn po_btn" style="float: right;"
                                                value="View SES Line Items" (click)="fetchSesLineItem()">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="field-section" [ngClass]="!isDisplayPDFViewer?'col-12':'col-6'">

                            <div *ngIf="isDOAExists && doaApproverList.length>0" class="doa_approver_list_sec">
                                <h4 class="approver_title">DOA Approver List
                                    <div class="search-box">
                                        <img src="../../../assets/img/search.png" alt="Search">
                                        <input type="search" (input)="searchDoaApprover=$any($event.target).value"
                                            autocomplete="off" class="search-input" placeholder="Search Approver">
                                    </div>
                                </h4>
                                <div class="approver_table_sec">
                                    <div class="table_section">
                                        <div class="table-responsive tablecss">
                                            <table class="table custom_table history_table">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <mat-icon role="button" (click)="selectedDOAApprover=0">
                                                                clear</mat-icon>
                                                        </th>
                                                        <ng-container *ngFor="let col of getKeys(doaApproverList[0])">
                                                            <th
                                                                *ngIf="col!='USER_ID' && (!isDOAParallel || (isDOAParallel && col!='DOA Level'))">
                                                                {{col}}
                                                            </th>
                                                        </ng-container>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <ng-container
                                                        *ngFor="let item of doaApproverList | listFilter:{'Approver':searchDoaApprover};let i=index">
                                                        <tr
                                                            *ngIf="isDOAParallel && (i==0 || (i>0 && doaApproverList[i]['DOA Level']!=doaApproverList[i-1]['DOA Level']))">
                                                            <td class="icon-cell">
                                                                <mat-radio-group name="rbgDOA"
                                                                    (change)="selectedDOAApprover=($event.value);"
                                                                    fxLayout="column">
                                                                    <mat-radio-button value="{{item.USER_ID}}"
                                                                        [checked]="doaApproverList.length==1 || selectedDOAApprover==item.USER_ID">
                                                                    </mat-radio-button>
                                                                </mat-radio-group>
                                                            </td>
                                                            <td [attr.colspan]="getKeys(doaApproverList[0]).length-2">
                                                                Level: {{item['DOA Level']}}
                                                            </td>
                                                        </tr>
                                                        <tr class="clr-blue">
                                                            <td *ngIf="isDOAParallel"></td>
                                                            <td *ngIf="!isDOAParallel" class="icon-cell">
                                                                <mat-radio-group name="rbgDOA"
                                                                    (change)="selectedDOAApprover=($event.value);"
                                                                    fxLayout="column">
                                                                    <mat-radio-button value="{{item.USER_ID}}"
                                                                        [checked]="doaApproverList.length==1 || selectedDOAApprover==item.USER_ID">
                                                                    </mat-radio-button>
                                                                </mat-radio-group>
                                                            </td>
                                                            <ng-container
                                                                *ngFor="let col of getKeys(doaApproverList[0])">
                                                                <td
                                                                    *ngIf="col!='USER_ID' && (!isDOAParallel || (isDOAParallel && col!='DOA Level'))">
                                                                    {{item[col]}}
                                                                </td>
                                                            </ng-container>
                                                        </tr>
                                                    </ng-container>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="transaction_tab_main_sec">
                                        <div class="t_tab_sec">
                                            <div class="transaction_tab_btn" *ngFor="let tab of dynamicTabs;let i=index"
                                                (click)="onTabClick(tab)"
                                                [class.active]="(tab.tab_name | lowercase)==(activeTab.tab_name | lowercase)">
                                                <div class="t_tab_icon_sec">
                                                    <img src="../../../assets/img/transaction/{{i==0?'general.png':'details.png'}}"
                                                        alt="Details">
                                                </div>
                                                <span class="t_tab_name_span">{{tab.tab_name}}</span>
                                                <span
                                                    *ngIf="tab.tab_field_type=='LINEITEM' || tab.tab_field_type=='POLINEITEM'"
                                                    class="icon_badge">{{lineLevelItemList.length}}</span>
                                            </div>
                                        </div>
                                        <div *ngIf="activeTab.tab_field_type=='NORMAL'" class="t_tab_content_mainsec">
                                            <div class="t_tab_content show" id="general-tab-content">
                                                <div class="row">
                                                    <div *ngFor="let item of transactionFieldList[activeTab.tab_id];let i=index"
                                                        class="details_main_section"
                                                        [class.col-lg-12]="isDisplayPDFViewer"
                                                        [class.col-lg-6]="!isDisplayPDFViewer"
                                                        >
                                                        <div class="row">
                                                            <div class="accordion processing-accordion" id="accordionExample">
                                                                <div class="accordion-item">
                                                                    <h2 class="accordion-header" [id]="'heading'+i">
                                                                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                                            [attr.data-bs-target]="'#collapse'+i" aria-expanded="true"
                                                                            [attr.aria-controls]="'collapse'+i">
                                                                            <h4 class="details_sub_heading">{{item.tab_header_name}}
                                                                            </h4>
                                                                        </button>
                                                                    </h2>
                                                                    <div [id]="'collapse'+i" class="accordion-collapse collapse show"
                                                                        aria-labelledby="'heading'+i" data-bs-parent="#accordionExample">
                                                                        <div class="accordion-body ">
                                                                            <div class="row">
                                                                                <ng-container *ngFor="let field of item.field_details;">
                                                                                    <div class="col-lg-6 col-sm-12">
                                                                                        <p class="details_title">{{field.field_name}}</p>
                                                                                        <p class="details_content">
                                                                                            <span *ngIf="field.control_type == 'DATE'">{{
                                                                                                field.field_value |
                                                                                                date:'dd-MMM-yyyy'}}</span>
                                                                                            <span
                                                                                                *ngIf="field.control_type == 'DROPDOWN'">{{field.dropdown_field_text==null?'-':field.dropdown_field_text}}</span>
                                                                                            <span
                                                                                                *ngIf="field.control_type != 'DATE' && field.control_type != 'DROPDOWN'">{{field.field_value==''?'-':field.field_value}}</span>
                                                                                        </p>
                                                                                    </div>
                                                                                </ng-container>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="activeTab.tab_field_type!='NORMAL'"
                                            class="t_tab_content_mainsec line_item_sec">
                                            <div class="t_tab_content show" id="general-tab-content">
                                                <div *ngIf="lineLevelItemList.length>0" class="general_form_sec">
                                                    <div class="table_main_sec">
                                                        <div class="table_section">
                                                            <div class="table-responsive tablecss mt10">
                                                                <table class="table custom_table history_table">
                                                                    <thead>
                                                                        <tr>
                                                                            <ng-container *ngIf="isPOLineItem">
                                                                                <ng-container
                                                                                    *ngFor="let col of getKeys(lineLevelItemList[0])">
                                                                                    <th *ngIf="(col|lowercase) !='id'">
                                                                                        {{col}}
                                                                                    </th>
                                                                                </ng-container>
                                                                            </ng-container>
                                                                            <ng-container *ngIf="!isPOLineItem">
                                                                                <th
                                                                                    *ngFor="let field of lineLevelItem.field_details">
                                                                                    {{field.field_name}}
                                                                                </th>
                                                                            </ng-container>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr *ngFor="let item of lineLevelItemList;let j=index"
                                                                            [ngClass]="j==0?'clr-blue':'clr-purple'">
                                                                            <ng-container *ngIf="isPOLineItem">
                                                                                <ng-container
                                                                                    *ngFor="let col of getKeys(lineLevelItemList[0])">
                                                                                    <td *ngIf="(col|lowercase) !='id'">
                                                                                        {{item[col]}}
                                                                                    </td>
                                                                                </ng-container>
                                                                            </ng-container>
                                                                            <ng-container *ngIf="!isPOLineItem">
                                                                                <td
                                                                                    *ngFor="let field of lineLevelItem.field_details">
                                                                                    {{item[field.db_column_name+'_text']}}
                                                                                </td>
                                                                            </ng-container>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div *ngIf="isDisplayPDFViewer" class="modelContent col-6">
                            <div class="pdf_section">
                                <!-- <ngx-extended-pdf-viewer
                                    [base64Src]="transactionDetail.invoice_file[0].invoice_file_encoded"
                                    [useBrowserLocale]="true" height="80vh" [showOpenFileButton]="false"
                                    [showBookmarkButton]="false">
                                </ngx-extended-pdf-viewer> -->
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</ng-template>

<ng-template #attachmentMail let-modal>
    <div class="ModelBox attachment_mail_container">
        <div class="box-title"><span>Attachment Mail</span> </div>
        <button mat-icon-button class="dialog-close-button" (click)="modal.dismiss('Cross click')">
            <mat-icon color="warn">close</mat-icon>
        </button>
        <div class="modelContent" [innerHTML]="attachmentMailContent">
        </div>
    </div>
</ng-template>

<ng-template #restrictedKeywordModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Keyword Replacement Chart</h5>
            <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                <div class="table_section">
                    <div class="table-responsive tablecss mt10">
                        <table class="table custom_table">
                            <thead>
                                <tr>
                                    <th>Keywords</th>
                                    <th>Auto Replacement</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of restrictedKeywords">
                                    <td>{{ item.restrict }}</td>
                                    <td>{{ item.replace }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #forwardApproverModal let-modal>
    <div class="modal-content sub-modal">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Select Approver to Forward</h5>
            <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                <div *ngIf="isDOAExists" class="doa_approver_list_sec">
                    <h4 class="approver_title">Approver List
                        <div class="search-box">
                            <img src="../../../assets/img/search.png" alt="Search">
                            <input type="search" (input)="searchForwardApprover=$any($event.target).value"
                                autocomplete="off" class="search-input" placeholder="Search Approver">
                        </div>
                    </h4>
                    <div class="approver_table_sec">
                        <div class="table_section">
                            <div class="table-responsive tablecss">
                                <table class="table custom_table history_table">
                                    <thead>
                                        <tr>
                                            <th>
                                                <mat-icon role="button" (click)="selectedForwardApprover=0">clear
                                                </mat-icon>
                                            </th>
                                            <ng-container *ngFor="let col of getKeys(forwardApproverList[0])">
                                                <th *ngIf="col!='USER_ID'">
                                                    {{col}}
                                                </th>
                                            </ng-container>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container
                                            *ngFor="let item of forwardApproverList | listFilter:{'Approver':searchForwardApprover};let i=index">
                                            <tr class="clr-blue">
                                                <td class="icon-cell">
                                                    <mat-radio-group name="rbgDOA"
                                                        (change)="selectedForwardApprover=($event.value);"
                                                        fxLayout="column">
                                                        <mat-radio-button value="{{item.USER_ID}}"
                                                            [checked]="forwardApproverList.length==1 || selectedForwardApprover==item.USER_ID">
                                                        </mat-radio-button>
                                                    </mat-radio-group>
                                                </td>
                                                <ng-container *ngFor="let col of getKeys(forwardApproverList[0])">
                                                    <td *ngIf="col!='USER_ID'">
                                                        {{item[col]}}
                                                    </td>
                                                </ng-container>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="text-center">
                            <button (click)="submitTransaction(doaMatrix.forward_process_id)"
                                class="btncss mr-2 mb-2 btn_primary btn_thin">
                                Forward
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #sesLineitemModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">SES Line Items</h5>
            <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                <div class="table_section">
                    <div class="table-responsive tablecss mt10">
                        <table class="table custom_table" *ngIf="sesLineitemList.length>0">
                            <thead>
                                <tr>
                                    <th *ngFor="let col of getKeys(sesLineitemList[0])">{{col}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of sesLineitemList">
                                    <td *ngFor="let col of getKeys(sesLineitemList[0])">{{ item[col] }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
